import moment from 'moment'
import router from '@/router'
import url from './urls'

const ACCESS_TOKEN_KEY = 'symposium_token'

function errorCaseNormal () {
  localStorage.removeItem(ACCESS_TOKEN_KEY)
  state.auth.isLogin = false
  window.location.href = '/symposium/video/login'
}

const state = {
  startData: '',
  endData: '',
  loadingDateAvailable: false,
  isPageNotFound: false,
  notDateActivate: true,
  isSymposiumClose: false,
  isSymposium: false,
  auth: {
    isLogin: false,
    isError: false
  },
  symposiums: [],
  symposiumDetail: null,
  rooms: []
}

const mutations = {
  CHECK_DATE_AVAILABLE (state) {
    state.isPageNotFound = false

    fetch(url.symposium.dateAvailable)
      .then((response) => response.json())
      .then((result) => {
        if (result.statusCode === 200) {
          state.startData = result.data.startDate
          state.endData = result.data.endDate

          const start = moment(state.startData)
          const end = moment(state.endData)
          const now = moment()

          if (now.diff(start) < 0 && now.diff(end) > 0) {
            state.notDateActivate = true
          } else {
            state.notDateActivate = false
          }

          if (end.isValid()) {
            state.isSymposiumClose = now.isAfter(end.endOf('day'))
          } else {
            console.error(
              'Invalid date format in state.startDate or state.endDate'
            )
            state.isSymposiumClose = false
          }
        } else if (result.statusCode === 404) {
          state.isPageNotFound = true
        } else {
          errorCaseNormal()
        }
      })
      .catch(() => {
        errorCaseNormal()
      })
  },

  SET_IS_SYMPOSIUM (state, routeName) {
    if (routeName && routeName.includes('symposium_video')) {
      state.isSymposium = true
    } else {
      state.isSymposium = false
    }
  },

  SIGN_IN_WITH_CODE (state, code) {
    state.isPageNotFound = false
    state.auth.isError = false

    const headers = new Headers()
    headers.append('Content-Type', 'application/json')

    const options = {
      method: 'POST',
      headers: headers,
      body: JSON.stringify({
        code: `${code}`
      })
    }

    fetch(url.symposium.signInWithCode, options)
      .then((response) => response.json())
      .then((result) => {
        if (result.statusCode === 200) {
          const accessToken = result.data.access_token
          localStorage.setItem(ACCESS_TOKEN_KEY, accessToken)
          state.auth.isLogin = true

          const symposiumRedirectVideoDetailId = sessionStorage.getItem(
            'symposium_redirect_video_detail_id'
          )

          if (symposiumRedirectVideoDetailId) {
            sessionStorage.removeItem('symposium_redirect_video_detail_id')
            router.push(`/symposium/video/${symposiumRedirectVideoDetailId}`)
          } else {
            router.push('/symposium/video')
          }
        } else if (result.statusCode === 404) {
          state.isPageNotFound = true
        } else {
          state.auth.isError = true
        }
      })
      .catch(() => {
        state.auth.isError = true
      })
  },

  GET_LIST (state, filter) {
    state.isPageNotFound = false
    state.symposiums = []

    const urlParams = new URLSearchParams()

    for (const [key, value] of Object.entries(filter)) {
      urlParams.append(key, value)
    }

    const header = new Headers()
    header.append('Authorization', localStorage.getItem(ACCESS_TOKEN_KEY))

    const options = {
      method: 'GET',
      headers: header
    }

    fetch(`${url.symposium.videoList}?${urlParams.toString()}`, options)
      .then((response) => response.json())
      .then((result) => {
        if (result.statusCode === 200) {
          state.symposiums = result.data.map((s) => {
            return {
              ...s,
              data: s.data.map((d) => {
                return {
                  ...d,
                  photo: d.photo.sort((a, b) => a.order_index - b.order_index)
                }
              })
            }
          })

          state.auth.isLogin = true
        } else if (result.statusCode === 404) {
          state.isPageNotFound = true
          state.auth.isLogin = true
        } else {
          errorCaseNormal()
        }
      })
      .catch(() => {
        errorCaseNormal()
      })
  },

  GET_DETAIL_BY_ID (state, id) {
    state.isPageNotFound = false
    state.symposiumDetail = null

    const header = new Headers()
    header.append('Authorization', localStorage.getItem(ACCESS_TOKEN_KEY))

    const options = {
      method: 'GET',
      headers: header
    }

    fetch(`${url.symposium.videoDetailById}${id}`, options)
      .then((response) => response.json())
      .then((result) => {
        if (result.statusCode === 200) {
          if (!result.data.is_active_symposium) {
            state.isPageNotFound = true
            state.auth.isLogin = true
          } else {
            state.symposiumDetail = result.data
            state.symposiumDetail.photo = state.symposiumDetail.photo.sort(
              (a, b) => a.order_index - b.order_index
            )
            state.auth.isLogin = true
          }
        } else if (result.statusCode === 404) {
          state.isPageNotFound = true
          state.auth.isLogin = true
        } else {
          errorCaseNormal()
        }
      })
      .catch(() => {
        errorCaseNormal()
      })
  },

  GET_ROOM_LIST (state, filter) {
    state.isPageNotFound = false
    state.rooms = []

    const urlParams = new URLSearchParams()

    for (const [key, value] of Object.entries(filter)) {
      urlParams.append(key, value)
    }

    const header = new Headers()
    header.append('Authorization', localStorage.getItem(ACCESS_TOKEN_KEY))

    const options = {
      method: 'GET',
      headers: header
    }

    fetch(`${url.symposium.roomList}?${urlParams.toString()}`, options)
      .then((response) => response.json())
      .then((result) => {
        if (result.statusCode === 200) {
          state.rooms = result.data
          state.auth.isLogin = true
        } else if (result.statusCode === 404) {
          state.isPageNotFound = true
        } else {
          errorCaseNormal()
        }
      })
      .catch((error) => {
        errorCaseNormal()
      })
  },

  LOGOUT () {
    errorCaseNormal()
  }
}

const actions = {
  checkDateAvailable ({ commit }) {
    commit('CHECK_DATE_AVAILABLE')
  },

  setIsSymposium ({ commit }, routeName) {
    commit('SET_IS_SYMPOSIUM', routeName)
  },

  checkForRedirectToListPage () {
    if (localStorage.getItem(ACCESS_TOKEN_KEY) !== null) {
      router.push('/symposium/video')
    }
  },

  signInWithCode ({ commit }, code) {
    commit('SIGN_IN_WITH_CODE', code)
  },

  getList ({ commit }, filter) {
    commit('GET_LIST', filter)
  },

  defaultList ({ state }) {
    state.symposiums = []
  },

  getDetailById ({ commit }, id) {
    commit('GET_DETAIL_BY_ID', id)
  },

  defaultDetail ({ state }) {
    state.symposiumDetail = null
  },

  getRoomList ({ commit }, filter) {
    commit('GET_ROOM_LIST', filter)
  },

  logout ({ commit }) {
    commit('LOGOUT')
  },

  defaultRoom ({ state }) {
    state.rooms = []
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
